// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddStageModalMutationVariables = Types.Exact<{
  input: Types.SaveGlobalPlanStageInput;
}>;


export type AddStageModalMutation = { __typename?: 'Mutation', saveGlobalPlanStage: { __typename?: 'SaveGlobalPlanStageResult', globalPlanStage: { __typename?: 'GlobalPlanStage', id: string } } };


export const AddStageModalDocument = gql`
    mutation AddStageModal($input: SaveGlobalPlanStageInput!) {
  saveGlobalPlanStage(input: $input) {
    globalPlanStage {
      id
    }
  }
}
    `;

/**
 * __useAddStageModalMutation__
 *
 * To run a mutation, you first call `useAddStageModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStageModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStageModalMutation, { data, loading, error }] = useAddStageModalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStageModalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddStageModalMutation, AddStageModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddStageModalMutation, AddStageModalMutationVariables>(AddStageModalDocument, options);
      }
export type AddStageModalMutationHookResult = ReturnType<typeof useAddStageModalMutation>;
export type AddStageModalMutationResult = ApolloReactCommon.MutationResult<AddStageModalMutation>;